import { render, staticRenderFns } from "./DateTimeConfig.vue?vue&type=template&id=88e9874e&scoped=true"
import script from "./DateTimeConfig.vue?vue&type=script&lang=js"
export * from "./DateTimeConfig.vue?vue&type=script&lang=js"
import style0 from "./DateTimeConfig.vue?vue&type=style&index=0&id=88e9874e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e9874e",
  null
  
)

export default component.exports